import { render, staticRenderFns } from "./BooksDownload.vue?vue&type=template&id=643d6dda"
import script from "./BooksDownload.vue?vue&type=script&lang=js"
export * from "./BooksDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports